import {AddUserType} from "../@const"
import ApiProjectUser from "../../../gd/api/project-user"
import ApiTask from "../../../gd/api/task"
import {AddUser_Manager} from "../model/manager"
import UsersToAdd from "../model/collection"
import Task from "../../../model2/task/task"
import Workspace from "../../../model2/space/workspaces/workspace"
import ProjectSession from "../../../model2/project/project-session"

// const debug = "AddUser_createUsers"
const debug = false

export default async function AddUser_createUsers(manager?: AddUser_Manager) {

    debug && console.log(debug, 'process', manager)

    if (!manager) {
        console.warn('AddUser_createUsers: no manager is passed')
        return
    }

    switch (manager.type) {
        case AddUserType.WORKSPACE_USER:
            if (!_.isEmpty(manager.companyUsersToAdd.selected)) {
                await AddUser_createWorkspaceUsers(manager.workspace, manager.companyUsersToAdd)
            }
            break

        case AddUserType.PROJECT_USER:
            if (manager.workspace) {
                if (!_.isEmpty(manager.companyUsersToAdd.selected)) {
                    // here we need create workspace users and then project users
                    await AddUser_createWorkspaceUsers(manager.workspace, manager.companyUsersToAdd)
                    await AddUser_createProjectUsers(manager.project, manager.companyUsersToAdd)
                }

                if (manager.workspaceUsersToAdd && !_.isEmpty(manager.workspaceUsersToAdd.selected)) {
                    await AddUser_createProjectUsers(manager.project, manager.workspaceUsersToAdd)
                }
            } else {
                if (!_.isEmpty(manager.companyUsersToAdd.selected)) {
                    await AddUser_createProjectUsers(manager.project, manager.companyUsersToAdd)
                }
            }
            break

        case AddUserType.TASK_USER:

            if (manager.workspace) {
                if (!_.isEmpty(manager.companyUsersToAdd.selected)) {
                    // here we need create workspace users and then project users
                    await AddUser_createWorkspaceUsers(manager.workspace, manager.companyUsersToAdd)
                    await AddUser_createProjectUsers(manager.project, manager.companyUsersToAdd)
                    await AddUser_createTaskUsers(manager.task, manager.companyUsersToAdd)
                }

                if (manager.workspaceUsersToAdd && !_.isEmpty(manager.workspaceUsersToAdd.selected)) {
                    await AddUser_createProjectUsers(manager.project, manager.workspaceUsersToAdd)
                    await AddUser_createTaskUsers(manager.task, manager.workspaceUsersToAdd)
                }

                if (manager.projectUsersToAdd && !_.isEmpty(manager.projectUsersToAdd.selected)) {
                    await AddUser_createTaskUsers(manager.task, manager.projectUsersToAdd)
                }
            } else {
                if (!_.isEmpty(manager.companyUsersToAdd.selected)) {
                    await AddUser_createProjectUsers(manager.project, manager.companyUsersToAdd)
                    await AddUser_createTaskUsers(manager.task, manager.companyUsersToAdd)
                }

                if (manager.projectUsersToAdd && !_.isEmpty(manager.projectUsersToAdd.selected)) {
                    await AddUser_createTaskUsers(manager.task, manager.projectUsersToAdd)
                }
            }
            break

        default:
            throw Error("#9484jjjj Not implemented")
    }
}

export async function AddUser_createWorkspaceUsers(workspace?: Workspace, usersToAdd?: UsersToAdd) {
    if (workspace && usersToAdd) {
        await ApiProjectUser.createWorkspaceUsers(workspace.id, usersToAdd.selected).promise()
    }
}

export async function AddUser_createProjectUsers(project?: ProjectSession, usersToAdd?: UsersToAdd) {
    if (project && usersToAdd) {
        await ApiProjectUser.createProjectUsers(project.id, usersToAdd.selected).promise()
    }
}

export async function AddUser_createTaskUsers(task?: Task, usersToAdd?: UsersToAdd) {
    if (task?.id && usersToAdd) {
        await ApiTask.createTaskUsers(task.id, usersToAdd.selected).promise()
    }
}